import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { ThemeContext } from "../context/ThemeProvider";

import { useNavigate } from "react-router-dom";
import { LAText, LAView } from "../components";
import { Rings } from "react-loader-spinner";
import { STRINGS } from "../constant";
import { GET_SCORE_QUESTIONS } from "../api/questions";

function UpdateAllQuestions(props) {
  const { profile, questionScrore, setAllQuestionData } =
    useContext(AuthContext);
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  useEffect(() => {
    startUpdating();
  }, []);

  async function startUpdating() {


    try {
 
    } catch (error) {
      console.log(error);
    }



    await getScoreQuestions();

    moveToHome();
  }

  async function getScoreQuestions() {
    const result = await GET_SCORE_QUESTIONS();
    setAllQuestionData(result?.data ?? []);
  }

  async function moveToHome() {
    const isAssesment =
      questionScrore?.all_question_scores?.length == 0 ? true : false;
    navigate("/updaterediness");
    navigate("/home", { state: { isAssesment: isAssesment } });

  }



  return (
    <>
      <LAView type="full-screen-center" flex="col" background="regular">
        <Rings
          height="80"
          width="80"
          color="#007054"
          radius="6"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          ariaLabel="rings-loading"
        />
        <LAText
          className="mt-3"
          size="small"
          font="400"
          color={"black"}
          title={STRINGS?.prepare_message}
        ></LAText>
      </LAView>
    </>
  );
}

export default UpdateAllQuestions;
